import { Box, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

interface NoDataProps {
  message?: string;
}

export function NoData({ message = "Nenhum dado disponível." }: NoDataProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 4,
        color: "text.secondary",
        textAlign: "center",
        height: "100%",
      }}
    >
      <InfoOutlined sx={{ fontSize: 40, mb: 1 }} />
      <Typography variant="body1">{message}</Typography>
    </Box>
  );
}
